export default "__VITE_ASSET__BMTyvY_E__$_?nuxt_component=async&nuxt_component_name=IconDocument&nuxt_component_export=default__"